<template>
  <div class="relative-pull mt-10" v-loading="loading">
    <div v-if="code == 'letter'" class="letter relative" style="overflow-y: scroll">
      <div class="richtext-box__letter box-shadow letter_box">
        <div class="rich-lettertop">主席的一封信</div>
        <div class="align-center">
          <img src="@/assets/img/letterheader.png" class="richtext-letterheader" />
        </div>

        <div class="richtext-box">
          <div v-html="content" class="richtext-text"></div>
        </div>
        <div class="align-center">
          <el-button type="primary" round @click="toList('公开的提问')">提问列表</el-button>
          <el-button type="primary" round @click="showQuestion">我要提问</el-button>
        </div>
        <div class="align-center"></div>
        <div class="rich-z__letter"></div>
        <div class="rich-letterbottom"></div>
        <div class="rich-letterbottom rich-letterbottom__blue"></div>
      </div>
    </div>

    <div v-else-if="code == 'pdf'">
      <el-main class="user-pdf">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="(item, index) in pdfurl" :key="index" :label="item.title" :name="item.active">
            <pdf ref="pdf" v-for="i in item.pdfinfo['numPages']" :key="i" :src="item.pdfinfo['src']" :page="i"></pdf>
          </el-tab-pane>
        </el-tabs>
        <!--<el-empty v-if="data == 'none'" description="无相关手册"></el-empty>
        <pdfh5 :url="filePathFormat(data.FilePaths)" v-else></pdfh5> -->
      </el-main>
    </div>

    <div v-else-if="code == 'duty'">
      <video v-if="dutyVisible" :src="dutyObject.video" controls autoplay class="video" width="100%">
        <source :type='dutyObject.video.type'></video>
      <el-main class="user-pdf" v-if="dutyObject.pdf">
        <!-- <el-empty v-if="data == 'none'" description="无相关手册"></el-empty>
        <pdfh5 :url="filePathFormat(data.FilePaths)" v-else></pdfh5> -->
        <div v-for="(item, index) in pdfurl" :key="index">
          <pdf v-for="i in item.pdfinfo['numPages']" :key="i" :src="item.pdfinfo['src']" :page="i"></pdf>
        </div>
      </el-main>
      <img v-if="dutyObject.pic != ''" style="margin-top: 16px" width="100%" :src="dutyObject.pic" />
    </div>
    <div v-else-if="code == 'rule'">
      <template v-if="benefitList.length != 0">
        <div class="benefit_con">
          <div v-if="src != ''">
            <el-image class="image" :src="src" :preview-src-list="[src]"></el-image>
          </div>
          <div class="benefit_con_info d2-ml-20">
            <div class="Title" v-html="Description"></div>
          </div>
        </div>
        <el-button class="btn_auto" type="primary" round v-if="checked.slot == 'birth' || checked.slot == 'marry'"
          @click="showFormHandle(checked.slot)">申请福利</el-button>
        <el-button class="btn_auto" type="primary" round v-if="checked.slot == 'subsidy'" @click="showSubsidyHandle()">
          申请补助</el-button>
        <el-button class="btn_auto" type="primary" round v-if="checked.slot == 'disease'" @click="showDiseaseHandle()">
          申请补助</el-button>
        <el-button class="btn_auto" type="primary" round v-if="checked.slot == 'majordisease'"
          @click="showMajorDiseaseHandle()">申请补助</el-button>
      </template>
      <el-empty class="auto" v-else></el-empty>
    </div>
    <!-- 信箱我要提问 -->
    <el-drawer title="我要提问" :before-close="cancelForm" :visible.sync="questionDialog" direction="rtl"
      :wrapperClosable='false' class="demo-drawer" ref="drawer">
      <div class="demo-drawer__content">
        <el-form ref="form" :model="form" :label-width="formLabelWidth" v-loading="loading"
          element-loading-text="提交中..." size="small">
          <el-form-item label="主题" prop="Title" :rules="[
              { required: true, message: '主题不能为空', trigger: 'blur' },
            ]">
            <el-input v-model="form.Title" autocomplete="off" placeholder="请输入主题名称"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="Email" :rules="[
              { required: true, message: '邮箱不能为空' },
              {
                type: 'email',
                message: '请输入正确的邮箱地址',
                trigger: 'blur',
              },
            ]">
            <el-input v-model="form.Email" autocomplete="off" placeholder="请输入邮箱" readonly></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="Content" :rules="[
              { required: true, message: '内容不能为空', trigger: 'blur' },
            ]">
            <el-input type="textarea" rows="4" v-model="form.Content" autocomplete="off" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="是否公开提问">
            <el-select v-model="form.IsOpen" placeholder="请选择是否公开提问" class="w100">
              <el-option v-for="val in option" :label="val.label" :value="val.value" :key="val.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button size="small" type="primary" @click="submitHandle" :loading="loading">{{
            loading ? "提交中 ..." : "确 定"
          }}</el-button>
          <el-button size="small" @click="cancelForm">取 消</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 生育 结婚慰问 -->
    <el-drawer :title="checked.name + '福利申请'" :before-close="cancelBirthForm" :visible.sync="birthDialog"
      direction="rtl" :wrapperClosable='false' class="demo-drawer" ref="drawerbirth">
      <div class="demo-drawer__content">
        <el-form ref="formbirth" :model="formbirth" :label-width="formLabelWidth" v-loading="loading"
          element-loading-text="提交中..." class="formbirth">
          <el-form-item label="申请人" prop="MemberName" :rules="[
              { required: true, message: '申请人不能为空', trigger: 'blur' },
            ]">
            <el-input v-model="formbirth.MemberName" autocomplete="off" placeholder="请输入申请人姓名" readonly></el-input>
          </el-form-item>
          <el-form-item label="入会日期" prop="RHRQ" :rules="[
              { required: true, message: '入会日期不能为空', trigger: 'blur' },
            ]">
            <el-date-picker v-model="formbirth.RHRQ" type="date" placeholder="请输入入会日期" readonly class="w100"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="申请福利" prop="SQFL" :rules="[
              { required: true, message: '申请福利不能为空', trigger: 'blur' },
            ]">
            <el-input v-model="formbirth.SQFL" autocomplete="off" placeholder="请输入申请福利" readonly></el-input>
          </el-form-item>
          <el-form-item label="申请日期" prop="CreateTime" :rules="[
              { required: true, message: '申请日期不能为空', trigger: 'blur' },
            ]">
            <el-date-picker v-model="formbirth.CreateTime" type="date" placeholder="请输入申请日期" readonly class="w100"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <template v-if="checked.slot == 'birth'">
            <el-form-item label="子女姓名" prop="ChildName" :rules="[
                {
                  required: true,
                  message: '子女姓名不能为空',
                  trigger: 'blur',
                },
              ]">
              <el-input v-model="formbirth.ChildName" autocomplete="off" placeholder="请输入子女姓名"></el-input>
            </el-form-item>
            <el-form-item label="证件类型" prop="CardType" :rules="[
                {
                  required: true,
                  message: '证件类型不能为空',
                  trigger: 'blur',
                },
              ]">
              <el-select v-model="formbirth.CardType" placeholder="请选择证件类型" class="w100">
                <el-option v-for="val in cardOption" :label="val.label" :value="val.value" :key="val.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号" prop="IDCard" :rules="[
                {
                  required: true,
                  validator: rulesUtils.idNumber,
                  trigger: ['change', 'blur'],
                },
              ]">
              <!-- <el-input v-model="formbirth.IDCard" autocomplete="off" placeholder="请输入证件号"></el-input> -->

              <el-input placeholder="请输入证件号"
                :value="!idCardVisible && !scancard?judgeCard(formbirth.IDCard):formbirth.IDCard"
                @input="formbirth.IDCard = $event"
                @focus="!first?showTipsDialog(formbirth.IDCard):!scancard?idCardVisible=true:''"
                @blur="!scancard?idCardVisible=false:''"><i slot="suffix"
                  :class="!idCardVisible?'el-icon-view':'el-icon-error'" :title="!idCardVisible?'查看完整证件号':'脱敏证件号'"
                  @click="IdCardHandle(idCardVisible)"></i></el-input>
            </el-form-item>
            <el-form-item label="子女性别" prop="Sex" :rules="[
                {
                  required: true,
                  message: '子女性别不能为空',
                  trigger: 'blur',
                },
              ]">
              <el-select v-model="formbirth.Sex" placeholder="请选择子女性别" class="w100">
                <el-option v-for="val in sexOption" :label="val.label" :value="val.value" :key="val.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出生日期" prop="Birth" :rules="[
                {
                  required: true,
                  message: '出生日期不能为空',
                  trigger: 'blur',
                },
              ]">
              <el-date-picker v-model="formbirth.Birth" type="date" placeholder="请输入出生日期" class="w100"
                format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </template>
          <template v-else-if="checked.slot == 'marry'">
            <el-form-item label="结婚日期" prop="JHRQ" :rules="[
                {
                  required: true,
                  message: '结婚日期不能为空',
                  trigger: 'blur',
                },
              ]">
              <el-date-picker v-model="formbirth.JHRQ" type="date" placeholder="结婚入出生日期" class="w100"
                format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </template>

          <el-form-item :label="checked.slot == 'birth' ? '出生证明' : '附件证明'" prop="Files" :rules="[
              { required: true, message: '附件不能为空', trigger: 'blur' },
            ]">
            <el-upload ref="upload" class="avatar-uploader" :on-remove="handleRemove" :on-exceed="handleExceed"
              action="#" :limit="10" :http-request="uploadFile" :show-file-list="false"
              :before-upload="beforeAvatarUpload">
              <template v-if="formbirth.Files">
                <img v-if="formbirth.Files != null" :src="$apiUrl + formbirth.Files" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </template>
              <template v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </template>
            </el-upload>
          </el-form-item>
          <el-form-item label="备注" prop="BZ">
            <el-input type="textarea" v-model="formbirth.BZ" autocomplete="off" placeholder="请输入备注" rows="3"
              maxlength="200" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button type="primary" @click="submitBirthHandle" :loading="loading" :disabled="birthBtn">
            {{ loading ? "提交中 ..." : "确 定" }}</el-button>
          <el-button @click="cancelBirthForm">取 消</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 会员申请补助 通用 -->
    <!--  @submit="getTableData" -->
    <edit-subsidy :subsidy="subsidy" :checked='checked' v-model="editSubsidyVisible" />
    <!-- 会员七类特种病补助 -->
    <!--  @submit="getTableData" -->
    <edit-disease :disease="disease" :checked='checked' v-model="editDiseaseVisible" />
    <!-- 会员直系亲属重大疾病补助 -->
    <!--  @submit="getTableData" -->
    <edit-major-disease :majordisease="majordisease" :checked='checked' v-model="editMajorDiseaseVisible" />

    <!--  -->
    <el-dialog title="提醒" :visible.sync="dialogVisible" width="50%" :before-close="handleClose" :append-to-body="true">
      <div class="web_view_con" v-html="htmlcon"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" plain size="small">取 消</el-button>
        <el-button type="primary" @click="showIdCard" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import pdf from "vue-pdf";
  import * as indexService from "@/api/sys/index";
  import dayjs from "dayjs";
  import rules from "@/libs/rules";
  import editSubsidy from "./editSubsidy";
  import editDisease from "./editDisease";
  import editMajorDisease from './editMajorDisease';
  import richTextData from "@/libs/richTextData";
  export default {
    name: "richText",
    components: {
      pdf,
      editSubsidy,
      editDisease,
      editMajorDisease
    },
    data() {
      return {
        type: "",
        rulesUtils: rules,
        questionDialog: false,
        birthDialog: false,
        loading: false,
        // 主席信箱 提问表单
        form: {
          Title: "",
          Email: "",
          Content: "",
          IsOpen: 0,
        },
        // 工会福利 申请表单
        formbirth: {
          MemberName: "",
          RHRQ: "",
          SQFL: "",
          CreateTime: "",
          ChildName: "",
          Sex: "",
          Birth: "",
          CardType: "",
          IDCard: "",
          Files: "",
          BZ: "",
          JHRQ: "",
        },
        option: [{
            // 下拉数据
            label: "否",
            value: 0,
          },
          {
            // 下拉数据
            label: "是",
            value: 1,
          },
        ],
        sexOption: [{
            // 下拉数据
            label: "男",
            value: "男",
          },
          {
            // 下拉数据
            label: "女",
            value: "女",
          },
        ],
        cardOption: [{
            label: "身份证",
            value: "身份证",
          },
          {
            label: "护照",
            value: "护照",
          },
          {
            label: "其他",
            value: "其他",
          },
        ],
        formLabelWidth: "100px",
        pdfurl: [],
        numPages: 1,
        benefitList: [], //规则
        dutyObject: {}, //职责
        dutyVisible: false,
        src: "",
        Description: "",
        birthBtn: false,
        subsidy: {},
        editSubsidyVisible: false,
        disease: {},
        editDiseaseVisible: false,
        majordisease: {},
        editMajorDiseaseVisible: false,
        activeName: 0,
        data: {},
        htmlcon: '',

        // 证件脱敏
        first: false,
        idCardVisible: false,
        scancard: false,
        dialogVisible: false,

        Isquestion: false,
      };
    },
    props: {
      code: {
        type: String,
        required: false,
        default: "",
      },
      content: {
        type: String,
        required: false,
        default: "",
      },
      menu: {
        type: Array,
        required: false,
        default: () => [],
      },
      name: {
        type: String,
        required: false,
        default: "",
      },
      checked: {
        type: Object,
        required: false,
        default: {},
      },
    },
    mounted() {},
    computed: {
      unitname() {
        return this.$store.state.d2admin.userInfo.userinfo;
      },
    },
    created() {
      this.pdfurl = [];
      if (this.code == "pdf") {
        let pdfList = []
        if (this.checked.name == '操作手册' && this.checked.shortTitle == '会员手册') {
          pdfList.push({
            Title: '小程序操作手册',
            FilePaths: "https://luoshi-oss.oss-cn-shanghai.aliyuncs.com/素材文件/罗氏工会小程序操作手册.pdf"
          });
        } else {
          if (this.content != '') pdfList = JSON.parse(this.content);
        }
        pdfList.map((v, index) => {
          this.pdfurl.push({
            title: v.Title,
            active: index + "",
            pdfinfo: {
              src: v.FilePaths,
              numPages: 1
            }
          });
          this.handelPdf1(this.pdfurl[index].pdfinfo);
        });
      } else if (this.code == "duty") {
        if (this.content != "") {
          let dutyList = JSON.parse(this.content);
          this.dutyObject = dutyList
          if (this.dutyObject.pdf) {
            let pdfList = []
            pdfList = this.dutyObject.pdf.split(",");
            pdfList.map((v) => {
              this.pdfurl.push({
                pdfinfo: {
                  src: v,
                  numPages: 1
                }
              });
              this.handelPdf();
            })
          } else if (this.dutyObject.video && this.dutyObject.video.src) {
            this.dutyVisible = true
          }
        }
      } else if (this.code == "rule") {
        if (this.content != "") {
          let benefitList = JSON.parse(this.content);
          this.benefitList = benefitList;
          this.Description = this.libText(benefitList[0].Description);
        }
      } else if (this.code == 'letter') {
        this.GetIsMember();
      }
    },
    watch: {
      content(val) {
        this.pdfurl = [];
        if (this.code == "pdf") {
          let pdfList = []
          if (this.checked.name == '操作手册' && this.checked.shortTitle == '会员手册') {
            pdfList.push({
              Title: '小程序操作手册',
              FilePaths: "https://luoshi-oss.oss-cn-shanghai.aliyuncs.com/素材文件/罗氏工会小程序操作手册.pdf"
            });
          } else {
            if (val != '') pdfList = JSON.parse(val);
          }
          pdfList.map((v, index) => {
            this.pdfurl.push({
              title: v.Title,
              active: index + "",
              pdfinfo: {
                src: v.FilePaths,
                numPages: 1
              }
            });
            this.handelPdf1(this.pdfurl[index].pdfinfo);
          });
        } else if (this.code == "duty") {
          if (this.content != "") {
            let dutyList = JSON.parse(this.content);
            this.dutyObject = dutyList
            if (this.dutyObject.pdf) {
              let pdfList = []
              pdfList = this.dutyObject.pdf.split(",");
              pdfList.map((v) => {
                this.pdfurl.push({
                  pdfinfo: {
                    src: v,
                    numPages: 1
                  }
                });
                this.handelPdf();
              })
            } else if (this.dutyObject.video && this.dutyObject.video.src) {
              this.dutyVisible = true
            }
          }
        } else if (this.code == "rule") {
          let benefitList = JSON.parse(val);
          this.benefitList = benefitList;
          this.Description = this.libText(benefitList[0].Description);
        } else if (this.code == 'letter') {
          this.GetIsMember();
        }
      },
      "formbirth.CardType": function (val) {
        this.rulesUtils.changeCardType(val);
        if (this.formbirth.IDCard || val) {
          if (
            this.formbirth.IDCard &&
            this.formbirth.IDCard.length === 18 &&
            this.formbirth.CardType == "身份证"
          ) {
            this.$refs.formbirth.validateField("IDCard", (e) => {
              if (!e) {
                this.formbirth.Birth =
                  this.formbirth.IDCard.substring(6, 10) +
                  "-" +
                  this.formbirth.IDCard.substring(10, 12) +
                  "-" +
                  this.formbirth.IDCard.substring(12, 14);
                this.formbirth.Sex =
                  parseInt(this.formbirth.IDCard.substr(16, 1)) % 2 == 1 ?
                  "男" :
                  "女";
              }
            });
          }
        }
      },
      // 计算初始日期
      "formbirth.IDCard": function (val) {
        if (this.formbirth.CardType || val) {
          let v = val;
          if (v.length === 18 && this.formbirth.CardType == "身份证") {
            this.$refs.formbirth.validateField("IDCard", (e) => {
              if (!e) {
                this.formbirth.Birth =
                  v.substring(6, 10) +
                  "-" +
                  v.substring(10, 12) +
                  "-" +
                  v.substring(12, 14);
                this.formbirth.Sex =
                  parseInt(v.substr(16, 1)) % 2 == 1 ? "男" : "女";
              }
            });
          }
        }
      },
    },
    methods: {
      handelPdf() {
        this.pdfurl.forEach(async (v, i) => {
          v.pdfinfo["numPages"] = await pdf.createLoadingTask(v.pdfinfo["src"]).promise.then((pdf) => {
            return pdf.numPages;
          });
        });
      },
      handelPdf1(item) {
        setTimeout(async () => {
          item.numPages = await pdf.createLoadingTask(item.src).promise.then((pdf) => {
            console.log(pdf.numPages)
            return pdf.numPages;
          });
        }, 500);
      },
      handleClick(tab, event) {},
      libText: function (str) {
        var div = document.createElement("div");
        div.innerHTML = str;
        if (div.getElementsByTagName("img").length > 0) {
          var u = div.getElementsByTagName("img")[0].getAttribute("src");
          this.src = this.getImgUrl(u);
          //删除第一个标签
          div.getElementsByTagName("img")[0].parentElement.remove();
        } else {
          this.src = "";
        }
        return div.innerHTML;
      },
      getImgUrl(url) {
        if (url == "" || url == undefined || url == null) {
          return "";
        }
        var u = url;
        if (u.indexOf("http") == 0) {
          return u;
        }
        u = this.$apiUrl + u;
        return u;
      },
      toList(item) {
        this.menu.forEach((v, index) => {
          if (v.title == item) {
            this.$emit("message", index, v.title, v.enTitle, v.type, v.code);
          }
        });
      },
      showQuestion() {
        if (this.Isquestion) {
          this.$message.warning("此账号不是会员,无法提问");
          return false;
        }
        this.questionDialog = true;
        this.form.Email = this.unitname.uInfo.Email;
      },
      showFormHandle(item) {
        this.birthDialog = true;
        this.GetIsMember();
        this.formbirth.MemberName = this.unitname.uInfo.Name;
        this.formbirth.RHRQ = this.unitname.uInfo.JoinMemberDay;
        this.formbirth.SQFL = this.checked.name;
        this.formbirth.CreateTime = dayjs().format("YYYY-MM-DD");
      },
      // 补助
      showSubsidyHandle() {
        this.editSubsidyVisible = true;
      },
      // 七大疾病补助
      showDiseaseHandle() {
        this.editDiseaseVisible = true;
      },
      // 亲属疾病补助
      showMajorDiseaseHandle() {
        this.editMajorDiseaseVisible = true;
      },
      GetIsMember() {
        indexService.GetIsMember().then((data) => {
          if (data.data.isMember == false) {
            if (this.code != 'letter') {
              this.$message.warning("此账号不是会员,无法申请");
            }
            this.Isquestion = true
            setTimeout(() => {
              this.birthDialog = false;
            }, 2000);
          } else {
            this.Isquestion = false
            if (this.code != 'letter') {
              this.GetWelfareApplyStatus();
            }
          }
        });
      },
      GetWelfareApplyStatus() {
        let query = {
          type: this.checked.name
        };
        indexService.GetWelfareApplyStatus(query).then((data) => {
          if (data.data.status != -1) {
            this.$message.warning(
              data.data.Actor ? data.data.Actor : "此账号已无法提交"
            );
            this.birthBtn = true;
            // setTimeout(() => {
            //   this.birthDialog=false;
            // }, 3000);
          } else {
            this.birthBtn = false;
          }
        });
      },
      handleClose(done) {
        if (this.loading) {
          return;
        }
        this.$confirm("确定要提交问题吗？")
          .then((_) => {
            this.loading = true;
          })
          .catch((_) => {});
      },
      cancelForm() {
        this.loading = false;
        this.questionDialog = false;
        this.form = {
          Title: "",
          Email: "",
          Content: "",
          IsOpen: 0
        };
      },
      cancelBirthForm() {
        this.loading = false;
        this.birthDialog = false;
        this.formbirth = {
          MemberName: "",
          RHRQ: "",
          SQFL: "",
          CreateTime: "",
          ChildName: "",
          Sex: "",
          Birth: "",
          CardType: "",
          IDCard: "",
          Files: "",
          BZ: "",
          JHRQ: "",
        };
      },
      // 我要提问提交
      submitHandle() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.loading = true;
            let form = {
              childrenData: [],
              dataId: 0,
              mainData: {
                Title: this.form.Title,
                Email: this.form.Email,
                Content: this.form.Content,
                IsOpen: this.form.IsOpen,
                GroupName: this.unitname.uInfo.GroupName,
                JoinMemberDay: this.unitname.uInfo.JoinMemberDay,
                Substation: this.unitname.uInfo.Substation,
              },
              shortTitle: this.name,
            };
            indexService
              .addQuestionData({
                ...form,
              })
              .then((data) => {
                this.$message.success("提问成功！");
                this.loading = false;
                this.questionDialog = false;
              })
              .catch((e) => {
                this.questionDialog = false;
              });
          } else {
            return false;
          }
        });
      },
      //上传图片
      beforeAvatarUpload(file) {
        let isLt2M = file.size < 1024 * 5120;
        let isJPG = ["image/jpeg", "image/png", "image/jpg"].includes(file.type);

        if (!isJPG) {
          this.$message.error("上传图片只能是 JPG/PNG/JPEG 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 2MB!");
        }
        return isJPG && isLt2M;
      },
      handleExceed() {
        this.$message({
          type: "warning",
          message: "只能上传一张图片!",
        });
      },
      handleRemove() {
        this.formbirth.Files = "";
      }, //上传图片
      uploadFile(item) {
        let _this = this;
        let rd = new FileReader(); // 创建文件读取对象
        let file = item.file;
        rd.readAsDataURL(file); // 文件读取装换为base64类型
        rd.onloadend = function (e) {
          _this.formbirth.Files = this.result;
        };
        let formdata = new FormData();
        formdata.append("image", item.file);
        indexService
          .uploadFile(formdata, item.file.name)
          .then((data) => {
            this.$message({
              type: "success",
              message: "图片上传成功!",
            });
            item.onSuccess();
            this.formbirth.Files = data.data.filepath;
          })
          .catch((error) => {
            item.onError();
          });
      },
      // 生育慰问福利 结婚慰问福利 申请提交
      submitBirthHandle() {
        this.$refs["formbirth"].validate((valid) => {
          if (valid) {
            this.loading = true;
            let form = {
              childrenData: [],
              dataId: 0,
              mainData: {
                MemberName: this.formbirth.MemberName,
                RHRQ: this.formbirth.RHRQ,
                SQFL: this.formbirth.SQFL,
                CreateTime: this.formbirth.CreateTime,
                Files: this.formbirth.Files,
                BZ: this.formbirth.BZ,
                Substation: this.unitname.uInfo.Substation,
                JoinMemberDay: this.formbirth.JoinMemberDay,
                GroupName: this.unitname.uInfo.GroupName,
                MemberCode: this.unitname.uInfo.AdAccount,
              },
              shortTitle: this.checked.submitTitle,
            };

            if (this.checked.slot == "birth") {
              form = {
                ...form,
                mainData: {
                  ...form.mainData,
                  ChildName: this.formbirth.ChildName,
                  Sex: this.formbirth.Sex,
                  Birth: this.formbirth.Birth,
                  CardType: this.formbirth.CardType,
                  IDCard: this.formbirth.IDCard,
                },
              };
            } else if (this.checked.slot == "marry") {
              form = {
                ...form,
                mainData: {
                  ...form.mainData,
                  JHRQ: this.formbirth.JHRQ,
                },
              };
            }
            indexService
              .addQuestionData({
                ...form,
              })
              .then((data) => {
                this.$message.success("申请成功！");
                this.loading = false;
                this.birthDialog = false;
              })
              .catch((e) => {
                this.birthDialog = false;
              });
          } else {
            return false;
          }
        });
      },
      //脱敏
      judgeCard(val) {
        if (!val) return ''
        let reg = /^(.{3}).*(.{2})$/
        return val.replace(/(?<=\d{3})\d{13}(?=\d{2})/, "************")
      },
      showTipsDialog(val) {
        if (!this.first && !this.idCardVisible && val != '') {
          this.dialogVisible = true;
          this.htmlcon = richTextData.confirmHtml;
          this.idCardVisible = true
        }
      },
      showIdCard() {
        this.dialogVisible = false;
        this.idCardVisible = true
        this.first = true;
      },
      // 证件脱敏切换
      IdCardHandle(flag) {
        this.idCardVisible = !this.idCardVisible;
        this.scancard = !this.scancard
      },
    },
    beforeDestroy() {
      // 销毁
    },
    destroyed() {}
  };
</script>

<style lang="scss" scoped>
  .letter_box {
    background: #ffffff;
    position: relative;
    width: auto;
    z-index: 5;
  }

  @import "~@/assets/style/style.css";
  @import "~@/assets/style/richText.scss";
</style>
<style scoped>
  .demo-drawer /deep/ .el-drawer__body {
    padding: 20px;
  }
</style>
<style lang="scss" scoped>
  /deep/.el-main {
    padding: 0;
  }

  .no-data {
    height: 500px;
    line-height: 500px;
    text-align: center;
    color: #606266;
  }

  .user-pdf {
    position: relative;
  }

  .pdf-name {
    position: absolute;
    left: 75px;
    display: block;
    width: 300px;
    height: 60px;
    line-height: 60px;
    background-color: #323639;
    color: #ffffff;
    font-weight: bold;
  }

  .benefit_con {
    display: flex;
    padding: 20px;
  }

  .benefit_con .image {
    height: 180px;
    width: auto;
  }

  .benefit_con_info {
    flex: 1;
  }

  .formbirth /deep/ .el-form-item__content {
    line-height: auto;
  }
</style>